import React from "react"
import TitleLabel from "../../Inputs/TitleLabel"
import InputField from "../../Inputs/InputField"
import styles from "./styles.css"
import InputDocument from "../../Inputs/InputDocument"
import PropTypes from "prop-types"

const CustomerEdit = ({ formikCustomer }) => {
  return (
    <div className={styles.container_edit}>
      <div>
        <TitleLabel>Nome do cliente</TitleLabel>
        <div className={styles.space_edit}>
          <InputField
            formValues={{
              name: "customerNewName",
              placeholder: "Nome completo"
            }}
            formik={formikCustomer}
          />
        </div>
      </div>

      <div>
        <TitleLabel>CPF ou CNPJ</TitleLabel>
        <div className={styles.space_edit}>
          <InputDocument
            formValues={{ name: "document", placeholder: "CPF ou CNPJ" }}
            formik={formikCustomer}
          />
        </div>
      </div>
    </div>
  )
}

CustomerEdit.propTypes = {
  formikCustomer: PropTypes.object.isRequired
}

export default CustomerEdit



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/ActionForm/CustomerEdit/index.js